import { useFormContext } from 'react-hook-form'

import styles from '../../GeoFenceCreateEdit.module.css'

export const FormErrorField = () => {
  const { formState } = useFormContext()

  return !formState.isValid && !formState.isValidating && formState.isSubmitted ? (
    <div className={styles.formError} data-testid="geofence-form-error">
      Adjust form fields and try again
    </div>
  ) : null
}
